import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  ALL_INCIDENTS_CLEAR,
  ALL_INCIDENTS_FILTERS_FETCH_LINKS_STATUS,
} from '../../../../actions/actionTypes';
import { translate } from '../../../../helpers/languageHelper';

export default fetchReducerGenerator(
  ALL_INCIDENTS_CLEAR,
  ALL_INCIDENTS_FILTERS_FETCH_LINKS_STATUS
);

const GROUP_NAMES_TO_IGNORE = ['TEST_OPEN', 'NONE'];

const getLinkStatusChildren = enforcementStatuses =>
  enforcementStatuses.map(({ literalKey, value }) => ({
    title: translate(literalKey),
    value: `enforcementStatus_${value}`,
    key: `enforcementStatus_${value}`,
  }));

const getAllIncidentsFiltersLinkStatusForProjection = responseData =>
  responseData
    .filter(({ name }) => !GROUP_NAMES_TO_IGNORE.includes(name))
    .map(({ enforcementStatusGroupId, literalKey, enforcementStatuses }) => ({
      title: translate(literalKey),
      value: `enforcementStatusGroup_${enforcementStatusGroupId}`,
      key: `enforcementStatusGroup_${enforcementStatusGroupId}`,
      children: getLinkStatusChildren(enforcementStatuses),
    }));

export const getAllIncidentsFiltersLinkStatusTreeData = state => {
  if (state.response && state.response.data) {
    return getAllIncidentsFiltersLinkStatusForProjection(state.response.data);
  } else {
    return [];
  }
};
